import { Box, type Breakpoint, Typography } from "@mui/material";
import type { Property } from "csstype";
import type { FC } from "react";
import { useTranslation } from "react-i18next";

type Props = {
	/** True renders the shared chart-error message in error color; false renders the "No Data" empty state. */
	isError: boolean;
	/** Footprint of the chart/KPI body it replaces — plain CSS value or MUI breakpoint record. */
	height: Property.Height | Partial<Record<Breakpoint, Property.Height>>;
};

/**
 * Shared error/empty body for the multi-facility cards: a centered message occupying the exact
 * footprint of the content it replaces, so cards keep their size across the three states.
 */
export const MultiFacilityChartStateBox: FC<Props> = ({ isError, height }) => {
	const { t } = useTranslation();
	return (
		<Box sx={{ width: "100%", height, display: "flex", justifyContent: "center", alignItems: "center" }}>
			<Typography sx={{ color: isError ? "error.main" : "text.secondary" }}>{isError ? t("mc.multi.chart.error") : t("No Data")}</Typography>
		</Box>
	);
};
